<template>
  <div class="boy_warp">
    <!-- <el-card style="height:100%"> -->
    <p>支柱产业构成分析</p>
    <div ref="echartsINof" style="height:100%"></div>
    <!-- </el-card> -->
  </div>
</template>

<script>
import { infoGrtBoy } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEchart();
  },
  methods: {
    async getInfoData() {
      const { code, data, msg } = await infoGrtBoy("r3");
      if (code) {
      }
    },
    handEchart() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        // tooltip: {
        //   trigger: "item",
        //   // formatter: "{a} <br/>{b}: {c} ({d}%)",
        // },
        legend: {
          // orient: "vertical",
          // left: "right",
          top: 10,
          itemWidth: 20,
          itemHeight: 20,
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            center: ["50%", "50%"],
            selectedMode: "single",
            data: [
              {
                value: 1548,
                name: "建筑板块",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "  {weatherHead|税收}{valueHead|24821万元}",
                    "{rate|26.55% }{we|}",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },
                    we: {
                      width: 10,
                      align: "right",
                    },
                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 4],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 735,
                name: "空天板块",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "  {weatherHead|税收}{valueHead|24821万元}",
                    "{rate|26.55% }{we|}",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },
                    we: {
                      width: 10,
                      align: "right",
                    },
                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 4],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 510,
                name: "测绘板块",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "  {weatherHead|税收}{valueHead|24821万元}",
                    "{rate|26.55% }{we|}",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },
                    we: {
                      width: 10,
                      align: "right",
                    },
                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 4],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 434,
                name: "医疗大健康板块",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "  {weatherHead|税收}{valueHead|24821万元}",
                    "{rate|26.55% }{we|}",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },
                    we: {
                      width: 10,
                      align: "right",
                    },
                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 4],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
              {
                value: 335,
                name: "其他",
                label: {
                  formatter: [
                    "{title|{b}}{abg|}",
                    "{hr|}",
                    "  {weatherHead|税收}{valueHead|24821万元}",
                    "{rate|26.55% }{we|}",
                    ,
                  ].join("\n"),
                  backgroundColor: "#eee",
                  borderColor: "#777",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    title: {
                      align: "center",
                    },
                    abg: {
                      width: "100%",
                      align: "right",
                      height: 25,
                      borderRadius: [4, 4, 0, 0],
                    },
                    Showers: {
                      height: 30,
                      align: "left",
                    },
                    weatherHead: {
                      color: "#333",
                      height: 24,
                      align: "left",
                      fontSize: 11,
                    },
                    hr: {
                      borderColor: "#777",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0,
                    },
                    value: {
                      width: 20,
                      padding: [0, 20, 0, 30],
                      align: "left",
                    },
                    valueHead: {
                      color: "#333",
                      width: 20,
                      fontSize: 11,
                      padding: [0, 20, 0, 30],
                      align: "center",
                    },
                    we: {
                      width: 10,
                      align: "right",
                    },
                    rate: {
                      color: "#fff",
                      backgroundColor: "#4C5058",
                      padding: [3, 4],
                      borderRadius: 4,
                      align: "right",
                    },
                  },
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.boy_warp {
  width: 100%;
  height: 100%;
  overflow: hidden;
  p {
    padding: 20px 20px 0 20px;
  }
  .el-card__body {
    height: 100%;
  }
}
</style>
